/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: e735fed0d13e
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

export const UriType = {
  Webhook: "webhook",
  Flow: "flow",
} as const;
export type UriType = ClosedEnum<typeof UriType>;

export const UriType$zodSchema = z.enum([
  "webhook",
  "flow",
]);
